import BlDatePickerMv from './BlDatePickerMv.vue'

BlDatePickerMv.install = function(Vue) {
  Vue.component(BlDatePickerMv.name, BlDatePickerMv)
}

export default BlDatePickerMv
